import { FC, Fragment, useContext, useEffect } from 'react';
import { FlightSearch, FlightSearchResponse } from 'ts/flight/interfaces/FlightSearch';
import { FlightFilterModel } from 'ts/flight/classes/FlightFilterModel';
import FlightResultFilter from './FlightResultFilter';
import FlightResultList from './FlightResultList';
import FlightResultListSkeleton from './FlightResultListSkeleton';
import { getSortedFlights } from 'utils/flight/flight';
import { FlightTopBarState } from 'ts/flight/classes/FlightTopBarStates';
import { RoundTripMode } from 'constants/flight';
import { FlightsResultContext } from 'contexts/FlightsResultContext';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface FlightResultProps {
  sortValue?: string;
  topBarState: FlightTopBarState;
  onChangeTopBarState: (state: FlightTopBarState) => void;
  roundTripMode: RoundTripMode;
  updateSearchDate?: Date;
  sessionStorageKey: string;
  setFlights: (flights?: FlightSearch[]) => void;
  flights?: FlightSearch[];
  response?: FlightSearchResponse;
  filter?: FlightFilterModel;
  setFilter: (filter: FlightFilterModel) => void;
}

const FlightResult: FC<FlightResultProps> = ({
  topBarState,
  response,
  flights,
  setFlights,
  setFilter,
  filter,
  ...props
}) => {
  const flightContext = useContext(FlightsResultContext);

  useEffect(() => {
    if (props.updateSearchDate) {
      setFlights(undefined);
    }
  }, [props.updateSearchDate]); //eslint-disable-line

  useEffect(() => {
    if (props.sortValue) {
      const newFlights = [...getSortedFlights(flights, props.sortValue)];

      setFlights(newFlights);
    }
  }, [props.sortValue]); // eslint-disable-line react-hooks/exhaustive-deps

  const onClickResetFilter = () => {
    const newFilter = new FlightFilterModel(flights!);

    setFilter(newFilter);
  };

  return (
    <Fragment>
      {flightContext?.roundTripMode === props.roundTripMode && (
        <Fragment>
          {!!flights?.length && (
            <div className="flight-results">
              {!!filter && (
                <FlightResultFilter
                  filter={filter}
                  setFilter={setFilter}
                  onClickReset={() => onClickResetFilter()}
                />
              )}

              <div className="flight-list">
                <FlightResultList
                  flights={flights.filter((flight) => flight.visible)}
                  sessionStorageKey={props.sessionStorageKey}
                />
              </div>
            </div>
          )}
          {!flights?.length && !topBarState.pollingFinished && !response?.sessionExpired && (
            <FlightResultListSkeleton />
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

export default withErrorBoundary(FlightResult, 'FlightResult');
